import { RIODateTime } from '#lib/RIODateTime.ts';

export const DEFAULT_TIME_VALUE = '00:00';
const DATE_FORMAT = RIODateTime.PREDEFINED_FORMATS.GERMAN_DATE;
const TIME_FORMAT = 'HH:mm';
const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

export const isValidTimeValue = (value?: string) =>
    value === undefined || value === '' || /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);

export const isValidDateValue = (value: string) => RIODateTime.TryParseLocal(value, DATE_FORMAT) !== undefined;

export const composeDateTimeValue = (date: string, time?: string) => {
    const normalizedTime = time && time.length > 0 ? time : DEFAULT_TIME_VALUE;
    const dateTime = RIODateTime.TryParseLocal(`${date} ${normalizedTime}`, DATE_TIME_FORMAT);

    if (!dateTime) {
        return '';
    }

    return dateTime.toISOString({ suppressMilliseconds: false }) ?? '';
};

export const splitDateTimeValue = (value?: string) => {
    const dateTime = RIODateTime.TryFromISO(value)?.toLocal();

    if (!dateTime) {
        return {
            date: '',
            time: '',
        };
    }

    return {
        date: dateTime.toPredefinedFormat(RIODateTime.PREDEFINED_FORMATS.GERMAN_DATE),
        time: dateTime.toFormat(TIME_FORMAT),
    };
};

export const dateFieldToJSDate = (value?: string) => RIODateTime.TryParseLocal(value ?? '', DATE_FORMAT)?.toJSDate();
